/**
 * /internal/loom - the Loom panel workbench.
 *
 * The workbench itself (viewer shell, assets, solver) is served by
 * thread-api at ``/api/loom-workbench/panels``. This page is only the frame: it
 * reads the Thread session, hands the access token to that route as a query
 * parameter, and embeds the result full-viewport. The API sets its own
 * HttpOnly cookie from that token, so the viewer's subresources and solve
 * calls authenticate without a token on every URL.
 *
 * Same shape as ``DocsPage`` (which frames ``/api/internal-docs``). The
 * @flexcompute.com gate lives in two places on purpose: ``FlexcomputeOnlyGuard``
 * in ``App.tsx`` keeps non-Flex users out of the UI, and the API re-checks the
 * identity on every request.
 */

import {
  buildLoomPanelWorkbenchUrl,
  LoomPanelWorkbenchSurface,
} from "../features/parametric-geometry/LoomPanelWorkbenchSurface";

/**
 * Authenticated entry URL for the workbench viewer shell.
 *
 * Exported so the token handling is unit-testable without rendering the page.
 */
export function buildLoomWorkbenchUrl(token: string): string {
  return buildLoomPanelWorkbenchUrl(token);
}

export default function LoomWorkbench() {
  return <LoomPanelWorkbenchSurface />;
}
